"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tr_1 = require("./Tr");
exports.default = Tr_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Tr/index.js
// module id = 254
// module chunks = 8